export default __webpack_public_path__ + "static/media/igpost2.96bd7348.png";